import {
  View,
  FlatList,
  TouchableOpacity,
  Image,
  StyleSheet,
} from "react-native";
import React from "react";
import color from "@constants/color";
import Text from "@components/AppText";

const TrendingSearch = (props) => {
  const { data = [], handleTrendingClicked } = props;

  const trendingSplit = React.useMemo(() => {
    const splitArrays = [];
    for (let index = 0; index < data.length; index += 2) {
      const pushValue = [];
      if (data[index]) pushValue.push(data[index]);
      if (data[index + 1]) pushValue.push(data[index + 1]);
      splitArrays.push(pushValue);
    }
    return splitArrays;
  }, [data]);

  const _renderItem = ({ item }) => {
    return (
      <View>
        <View>
          <TouchableOpacity
            testID="trending-r1"
            key={item[0].text}
            style={{ marginRight: 12, marginBottom: 16 }}
            onPress={() => handleTrendingClicked(item[0])}
          >
            <View style={styles.imgContainer}>
              <Image
                style={{ height: 50, width: 50 }}
                resizeMode="cover"
                source={{ uri: item[0].image }}
              />
            </View>
            <Text style={styles.imgText}>{item[0]?.text}</Text>
          </TouchableOpacity>
        </View>
        {item.length > 1 ? (
          <View>
            <TouchableOpacity
              testID="trending-r2"
              key={item[1].text}
              onPress={() => handleTrendingClicked(item[1])}
              style={{ marginRight: 12, marginBottom: 16 }}
            >
              <View style={styles.imgContainer}>
                <Image
                  style={{ height: 50, width: 50 }}
                  resizeMode="cover"
                  source={{ uri: item[1].image }}
                />
              </View>
              <Text style={styles.imgText}>{item[1]?.text}</Text>
            </TouchableOpacity>
          </View>
        ) : null}
      </View>
    );
  };

  const keyExtractor = (i, index) => `${i?.text}${index}`;

  if (data.length === 0) return null;
  return (
    <View
      style={{
        paddingBottom: 12,
        backgroundColor: color.white,
        paddingLeft: 16,
      }}
    >
      <Text
        semiBold
        style={{
          color: color.mediumBlack,
          marginVertical: 8,
          fontSize: 16,
          lineHeight: 22,
        }}
        fontType="head2"
      >
        Popular
      </Text>
      <View style={styles.chipBox}>
        <FlatList
          contentContainerStyle={{
            alignSelf: "flex-start",
            marginTop: 8,
          }}
          key="TRENDING_SUGGESTIONS"
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          renderItem={_renderItem}
          initialNumToRender={5}
          data={trendingSplit}
          horizontal
          keyExtractor={keyExtractor}
          keyboardShouldPersistTaps="always"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  imgContainer: {
    padding: 6,
    borderWidth: 1,
    borderRadius: 8,
    borderColor: "rgba(23, 141, 227, 0.16)",
    marginBottom: 8,
  },
  imgText: {
    color: color.mediumBlack,
    fontWeight: "400",
    fontSize: 12,
    textAlign: "center",
  },
  chipBox: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
});

export default TrendingSearch;
